import React from 'react'
import LOGO from '../../assets/main-logo.png'
import PLAYER1ICON from '../../assets/player-1.png'
import PAYLER2ICON from '../../assets/player-2.png'
import './logo.css'


const Logo = ({ }) => {

    return (
        <div className='logo__container'>
            <img src={PLAYER1ICON} className="second__logo" alt="logo" ></img>
            <img src={LOGO} className="main__logo" alt="logo"></img>
            <img src={PAYLER2ICON} className="second__logo" alt="logo" ></img>
        </div>
    )
}

export { Logo }